<div class="contactus-popup" *ngIf="isVisible" @slideInOut (@slideInOut.done)="onAnimationDone($event)">
  <div class="popup-title-container">
    <img src="assets/tree-editor/left_pane/btn_left_pane_closed.svg" alt="Close" class="close-icon" (click)="close()"/>

    <div class="popup-title-text">{{ "support_popup.lbl_contact_us" | translate }}</div>
  </div>

  <div class="popup-content">
    <div *ngIf="isLoadingVisible" class="popup-spinner">
      <img src="/assets/images/icons/loading.svg" alt="Loading..." />
    </div>

    <div class="popup-header">
       <h2>{{ "support_popup.lbl_contact_us" | translate }}</h2>
    </div>

    <div class="popup-body">     
      <form [formGroup]="supportForm" (ngSubmit)="onSubmit()" class="contact-form">
        <label for="message" class="form-label">{{'support_popup.lbl_message' | translate}}</label>
        <textarea id="message" rows="4" class="form-control" formControlName="message" maxlength="1500"
          placeholder="{{ 'support_popup.lbl_type_message' | translate }}" [ngClass]="{ 'border-danger': isValid('message') }"
          (focus)="onMessageFocus()">
        </textarea>

        <div *ngIf="apiErrorMessage" class="text-danger">
          {{ apiErrorMessage }}
        </div>

        <div *ngIf="supportForm.get('message')?.value?.length === 1500" class="text-danger">
          {{ 'support_popup.lbl_message_length' | translate }}
        </div>

        <div class="d-flex justify-content-end mt-3">
          <button type="submit" class="ft-btn" [ngClass]="supportForm.valid ? 'ft-btn-active' : 'ft-btn-inactive'"
          [disabled]="!supportForm.valid || isLoadingVisible">
          {{ 'more_help.contact_form.lbl_send' | translate }}
          </button>
        </div>
      </form>

      <div *ngIf="isContactSuccess" class="success-text">
        <img src="assets/images/successIcon.svg" alt="successIcon">
        <h1 class="text"> {{ "support_popup.lbl_contact_success" | translate }}</h1>
      </div>

    </div>

    <div class="popup-footer">
      <button class="ft-btn ft-btn-active-not-selected" (click)="close()">
        {{ "lbl_cancel" | translate }}
      </button>
    </div>
  </div>
</div>
